import { createFileRoute } from '@tanstack/react-router';
import { PublicDocPage } from '@/features/docs/public-doc-page';

export const Route = createFileRoute('/share/doc/$token')({
  validateSearch: (search: Record<string, unknown>): { page?: string } => ({
    ...(typeof search.page === 'string' ? { page: search.page } : {}),
  }),
  component: ShareRoute,
});

function ShareRoute() {
  const { token } = Route.useParams();
  const { page } = Route.useSearch();
  return <PublicDocPage token={token} pageId={page} />;
}
